@for (name of names; track name) {
  <aa-routlet [name]="name"></aa-routlet>
}
